// extracted by mini-css-extract-plugin
var _1 = "RentalPortalViewRegimeControl-moduleRentalPortalViewRegimeControl__waaUF";
export { _1 as "RentalPortalViewRegimeControl" }
